import type { ClipboardPayload } from '@model-framework/clipboard';

const Target = 'Any'; // 情報として不要だがClipboardPayloadの互換性のためセット
const ContentType = 'files';

export type FileClipboardPayload = ClipboardPayload & {
  target: typeof Target;
  contentType: typeof ContentType;
  files: File[];
};

export namespace FileClipboardPayload {
  export function fromFiles(files: File[]): FileClipboardPayload {
    return {
      target: Target,
      contentType: ContentType,
      files,
    };
  }
}

export const isFileClipboardPayload = (payload: ClipboardPayload): payload is FileClipboardPayload => {
  if (payload.contentType !== ContentType) return false;
  const { files } = payload as { files?: unknown };
  return Array.isArray(files) && files.every((file) => file instanceof File);
};
